import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
  inject,
  signal
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { zoomInOut } from "../../core-ui.animations";
import { AudioInterruptionService } from "../../services";

@Component({
  selector: "app-audio-interruption-overlay",
  templateUrl: "./audio-interruption-overlay.component.html",
  styleUrls: ["./audio-interruption-overlay.component.scss"],
  animations: [zoomInOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AudioInterruptionOverlayComponent implements OnInit {
  private audioInterruption = inject(AudioInterruptionService);
  private destroyRef = inject(DestroyRef);

  readonly visible = signal(false);
  readonly recovering = signal(false);

  ngOnInit() {
    this.audioInterruption.isInterrupted$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isInterrupted) => {
        this.visible.set(isInterrupted);
        if (!isInterrupted) {
          this.recovering.set(false);
        }
      });

    this.audioInterruption.showOverlay$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.visible.set(true);
      });
  }

  dismiss() {
    // UI-only hide. The interruption state stays untouched — it only changes
    // from the service. If the user tries to unmute while still interrupted,
    // the overlay re-surfaces via showOverlay$.
    this.visible.set(false);
  }

  async resume() {
    if (this.recovering()) {
      return;
    }
    this.recovering.set(true);
    try {
      await this.audioInterruption.attemptRecovery();
    } finally {
      this.recovering.set(false);
    }
  }
}
